<div class="data">
    <div class="data__value mtv-primary-color" (click)="toggleDetails()">
        {{value}}
    </div>

    <div class="data__details" [class.active]="isShow">
        <div class="wrapper">
            <dl *ngFor="let item of data">
                <dt *ngIf="item.building">{{item.building.name}}</dt>
                <dd *ngIf="item.role">{{item.role.name}}</dd>
            </dl>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/buildings/buildings.component.html